import { api } from "./client";
import type { PermissionOverride } from "@/lib/permissions";

interface ApprovalOptions {
  approvalToken?: string;
}

export interface OverridesResponse {
  overrides: PermissionOverride[];
}

export async function getPermissionOverrides(): Promise<OverridesResponse> {
  const raw = (await api.get("/permissions/overrides")) as OverridesResponse;
  return { overrides: raw.overrides ?? [] };
}

export async function getMyPermissionOverrides(): Promise<OverridesResponse> {
  const raw = (await api.get(
    "/permissions/overrides/mine"
  )) as OverridesResponse;
  return { overrides: raw.overrides ?? [] };
}

export function updatePermissionOverrides(
  data: Record<string, unknown>,
  options?: ApprovalOptions
) {
  return api.post("/permissions/overrides", data, {
    headers: options?.approvalToken
      ? { Authorization: `Bearer ${options.approvalToken}` }
      : undefined,
  });
}

export function resetPermissionOverrides(
  data?: Record<string, unknown>,
  options?: ApprovalOptions
) {
  return api.post("/permissions/overrides/reset", data ?? {}, {
    headers: options?.approvalToken
      ? { Authorization: `Bearer ${options.approvalToken}` }
      : undefined,
  });
}
